interface BlueWrapperProps {
  children: React.ReactNode;
}

export const BlueWrapper = ({ children }: BlueWrapperProps) => (
  <div className="dark:bg-tertiary border-tertiary grid gap-4 rounded-2xl border bg-blue-100 p-6">
    {children}
  </div>
);
